function Language() {
    "use strict";

    this.__type = 'Language:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.Description = '';
    this.LanguageCode = '';
}
if (typeof exports !== 'undefined') {
    module.exports = Language;
}